module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Day-rain-6bc91ecd3ed50de939ba55c4346238ac.svg";